import type { Location } from './types'

export interface DestinationDetail {
  locationId: Location['id']
  image: string
  spaImage: string
  description: string
  landmarks: string[]
  spas: string[]
  perfectFor: string[]
  ratings: Record<'Cost' | 'Nature' | 'Spa' | 'Food' | 'Walkability' | 'Relaxation', number>
}

export const DESTINATIONS: DestinationDetail[] = [
  {
    locationId: 'calgary',
    image: 'https://cdn.magicpatterns.com/uploads/veM2YoZZbXGQqfZwnhFXzy/Banff_Calgary_Alberta.jpg',
    spaImage: 'https://cdn.magicpatterns.com/uploads/nP2Ld4mz5w3fbfweCPVBXC/Nordic_Spa_Banff.jpg',
    description: 'A restorative mountain escape where crisp alpine air, dramatic peaks, and quiet luxury set the tone for meaningful conversations.',
    landmarks: ['Banff National Park', 'Lake Louise', 'Calgary Tower'],
    spas: ['Kananaskis Nordic Spa', 'Fairmont Banff Springs Spa'],
    perfectFor: ['Mountain scenery', 'Fresh air', 'Adventure', 'Luxury wellness'],
    ratings: { Cost: 4, Nature: 5, Spa: 5, Food: 4, Walkability: 5, Relaxation: 5 },
  },
  {
    locationId: 'vancouver',
    image: 'https://cdn.magicpatterns.com/uploads/3PTmJDdEG23HPmbWGn26fG/Marina_at_Coal_Harbour_Vancouver_BC.jpg',
    spaImage: 'https://cdn.magicpatterns.com/uploads/h2d2tnAuk7kfNCkkh8dDdD/Fairmont_Pacific_Rim_-_Vancouver_BC.jpg',
    description: 'Ocean energy meets forest calm in a highly walkable city known for exceptional food, polished hotels, and effortless views.',
    landmarks: ['Stanley Park', 'Granville Island', 'Capilano Suspension Bridge'],
    spas: ['Fairmont Pacific Rim Spa', 'Scandinave Spa, Whistler'],
    perfectFor: ['Ocean views', 'Food', 'Walkability', 'Luxury'],
    ratings: { Cost: 2, Nature: 5, Spa: 5, Food: 5, Walkability: 5, Relaxation: 4 },
  },
  {
    locationId: 'halifax',
    image: 'https://cdn.magicpatterns.com/uploads/uqZiFxGz32imgppvK2R7bS/Peggys_Cove_Halifax_Nova_Scotia.jpg',
    spaImage: 'https://cdn.magicpatterns.com/uploads/13G9MGM3GpejqdM2acRH5g/Oceanstone_Resort_-_Halifax_Nova_Scotia.jpg',
    description: 'A gentler pace by the Atlantic, with salt-air scenery, storied waterfronts, and the kind of hospitality that lets a group truly unwind.',
    landmarks: ["Peggy's Cove", 'Halifax Waterfront', 'Citadel Hill'],
    spas: ['Sensea Nordic Spa', 'Oceanstone Spa'],
    perfectFor: ['Coastal relaxation', 'Fresh seafood', 'Quiet atmosphere'],
    ratings: { Cost: 4, Nature: 4, Spa: 5, Food: 4, Walkability: 3, Relaxation: 4 },
  },
  {
    locationId: 'toronto',
    image: 'https://cdn.magicpatterns.com/uploads/9xQpndVmf1FUjwxCinW2eK/Toronto_CN_Tower_.jpg',
    spaImage: 'https://cdn.magicpatterns.com/uploads/7bBzDnDjz5C3sRB5XLugvC/Elmwood_Spa_Toronto_Ontario.jpg',
    description: 'A cosmopolitan gathering place with acclaimed restaurants, direct connections, and a lively city rhythm just beyond the boardroom.',
    landmarks: ['CN Tower', 'Distillery District', 'Toronto Islands'],
    spas: ['Elmwood Spa', 'Four Seasons Spa'],
    perfectFor: ['Food', 'Entertainment', 'Convenience'],
    ratings: { Cost: 2, Nature: 3, Spa: 5, Food: 5, Walkability: 4, Relaxation: 3 },
  },
  {
    locationId: 'montreal',
    image: 'https://cdn.magicpatterns.com/uploads/sstR5y68NyU7S3eizhEm73/Montreal_3.jpg',
    spaImage: 'https://cdn.magicpatterns.com/uploads/iZpoq8huB25rQnF8mFHtcT/Bota_Bota_Spa_Montreal.jpg',
    description: 'European charm, creative energy, and memorable dining make this a richly textured setting for reflection and fresh perspective.',
    landmarks: ['Old Montréal', 'Mount Royal', 'Notre-Dame Basilica'],
    spas: ['Bota Bota Floating Spa', 'Scandinave Spa Montréal'],
    perfectFor: ['European charm', 'Culture', 'Amazing restaurants', 'Luxury wellness'],
    ratings: { Cost: 3, Nature: 3, Spa: 5, Food: 5, Walkability: 5, Relaxation: 3 },
  },
]

export function getDestinationDetail(locationId: string): DestinationDetail | undefined {
  return DESTINATIONS.find((destination) => destination.locationId === locationId)
}
